module.exports = __webpack_public_path__ + "static/hf-logo-7007bfaf409aee060ac7ecac956f8691.png";